/**
 * @file index.tsx
 *
 * @fileoverview Renders blog search form.
 */
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { PathContext } from '~/jobiqo/context/app';
import { PathContextInterface } from '~/jobiqo/models/app';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { Input } from '~/vcl/atoms/01-forms/03-input';
import { FormItemsInline } from '~/vcl/molecules/01-form/03-form-items-inline';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface BlogSearchFormProps {
  /**
   * On submit callback.
   */
  onSubmit: (keyword: string) => void;
}

export default function BlogSearchForm({ onSubmit }: BlogSearchFormProps) {
  const { querystring }: PathContextInterface = useContext(PathContext);
  const intl = useIntl();
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);
  const { handleSubmit, setValue, register } = useForm({
    defaultValues: {
      keyword: querystring?.search ?? '',
    },
  });

  return (
    <form
      id="blog_search_input_form"
      onSubmit={handleSubmit((formData) => onSubmit(formData.keyword))}
    >
      <FormItemsInline
        inputs={[
          <Input
            key="keyword"
            {...register('keyword')}
            placeholder={intl.formatMessage({
              id: 'blog_search',
              defaultMessage: 'Search blogs...',
            })}
            type="text"
            size={50}
            onChange={(event) => setValue('keyword', event.target.value)}
            onClear={() => {
              setValue('keyword', '');
              onSubmit('');
            }}
          />,
        ]}
        button={
          <Button
            type="submit"
            buttonStyle={frontendTheme.SEARCH_FORM.BUTTON_STYLE}
          >
            <span>
              <FormattedMessage
                id="search_inputs_submit"
                defaultMessage="Search"
              />
            </span>
          </Button>
        }
      />
    </form>
  );
}

export { BlogSearchForm };
